<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="tab.route === activeTab">
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Income',
  data () {
    return {
      activeTab: null
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { tabMenu: 'menu.income.cashClosings', name: 'CashClosings', route: `/income/cash-closings`, roles: ['manager'] },
        { tabMenu: 'menu.income.movements', name: 'Movements', route: `/income/movements`, roles: ['manager'] },
        { tabMenu: 'menu.income.collection', name: 'Collection', route: `/income/collection`, roles: ['manager'] },
        { tabMenu: 'menu.income.billing', name: 'Billing', route: `/income/billing`, roles: ['manager'] }
      ]
      return tabs.filter(tab => tab.roles.includes(this.$is()))
    }
  }
}
</script>
